// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3bxd4","amount":"Amount_amount__3AEjS","tip":"Amount_tip__3l7FH","tipHeader":"Amount_tipHeader__36np6","tipsWrap":"Amount_tipsWrap__2-vc-"};